'use strict';

const radioTokens = (theme) => ({
    radioSize: '1.125rem',
    radioBorderWidth: '1px',
    radioColor: theme.palette.grey500,
    // focused
    radioFocusShadow: `0 0 0 ${theme.space.component.x.xs} ${theme.palette.blue400Alpha}`,
    // checked
    radioCheckedBorderWidth: '2px',
    radioCheckedColor: theme.colors.primary.normal,
    radioInnerCircleSize: `${1.125 - 0.625}rem`,
    // disabled
    radioDisabledColor: '#bdc6d9',
    // checked and disabled
    radioCheckedDisabledColor: '#a8c4ff',
});

exports.radioTokens = radioTokens;
//# sourceMappingURL=radio.js.map
